export default __webpack_public_path__ + "static/media/melech-smile_lowres.10ba7d6a.jpg";